module.exports = __webpack_public_path__ + "img/security_d.4cbe1ed.svg";